export enum ELineStyle {
    DASHED = 'dashed',
    DOTTED = 'dotted',
    SOLID = 'solid',
}
